<template>
  <div class="dashboard">
    <div v-if="guarantorLoaded">
      <div v-if="$store.getters.guarantorInfo.status===0">
        <Alert type="error" show-icon>
          请登记
          <template slot="desc">
            还未进行保证人登记
            <Button type="error" to="/guarantors/new">去登记</Button>
          </template>
        </Alert>
      </div>
      <div v-if="$store.getters.guarantorInfo.status===1">
        <Alert type="warning" show-icon>
          登记预审中
          <template slot="desc">
            您的保证人登记信息正在被预审中，请耐心等待
          </template>
        </Alert>
      </div>
      <div v-if="$store.getters.guarantorInfo.status===2">
        <Alert type="warning" show-icon>
          登记审核中
          <template slot="desc">
            您的保证人登记信息已通过预审，请打印备案表，携带所有文件进行现场备案。
            <Button type="info" to="/guarantors/preview">打印备案表</Button>
          </template>
        </Alert>
      </div>
      <div v-if="$store.getters.guarantorInfo.status===99">
        <Alert type="error" show-icon>
          未通过审核
          <template slot="desc">
            很遗憾，您的保证人登记信息未通过审核被退回，请修改后重新提交申请。<br>
            原因：{{$store.getters.guarantorInfo.comment}}<br>
            时间：{{$store.getters.guarantorInfo.auditTime}}<br>
            <Button type="error" :to="`/guarantors/edit/${$store.getters.guarantorInfo.id}?own=true`">修改申请</Button>
          </template>
        </Alert>
      </div>
      <Alert show-icon type="error" v-if="$store.getters.guarantorInfo.status===40">
        该机构被列入黑名单！
        <template slot="desc">
          <p v-if="$store.getters.guarantorInfo.blacklistReason">
            原因：<span v-html="$store.getters.guarantorInfo.blacklistReason"></span>
          </p>
          <p v-if="$store.getters.guarantorInfo.blacklistFacts">
            违规事实：<span v-html="$store.getters.guarantorInfo.blacklistFacts"></span>
          </p>
          <p v-if="$store.getters.guarantorInfo.blacklistExpires">
            黑名单结束时间：{{require('moment')($store.getters.guarantorInfo.blacklistExpires).format('YYYY-MM-DD')}}
          </p>
        </template>
      </Alert>
    </div>
    <div>
      <Row :gutter="16">
        <Col :sm="24" :md="24" :lg="14">
          <Card style="height:400px;overflow: hidden;">
            <dashboard-gua-list-block v-if="$store.getters.userInfo.displayName" />
          </Card>
        </Col>
        <Col :sm="24" :md="24" :lg="10">
          <Card style="height:400px;overflow: hidden;">
            <vue-scroll>
              <dashboard-stat-figures-block />
            </vue-scroll>
          </Card>
        </Col>
      </Row>
      <div class="padding-top-20"></div>
    </div>
    <div class="">
      <Row :gutter="16">
        <Col :sm="24" :md="24" :lg="14">
          <Card style="height:400px;overflow: hidden;">
            <dashboard-announcement-block v-if="$store.getters.userInfo.displayName" />
          </Card>
        </Col>
        <Col :sm="24" :md="24" :lg="10">
          <Card style="height:400px;overflow: hidden;">
            <dashboard-user-info-block @changePwd="changePwd" @bindMobile="bindMobile" />
          </Card>
        </Col>
      </Row>
      <div class="padding-top-20"></div>
    </div>
    <div class="" v-if="guarantorLoaded&&$common.userType[$store.getters.userInfo.type.toString()]==='保证人'">
      <Row :gutter="16">
        <Col :sm="24" :md="24" :lg="14">
          <Card style="height:400px;overflow: hidden;">
            <dashboard-guarantor-info-block />
          </Card>
        </Col>
        <Col :sm="24" :md="24" :lg="10">
          <Card style="height:400px;overflow: hidden;">
            <dashboard-guarantor-allowrance-block />
          </Card>
        </Col>
      </Row>
      <div class="padding-top-20"></div>
    </div>
  </div>
</template>

<script>
import DashboardUserInfoBlock from './../components/DashboardUserInfo.vue'
import DashboardGuarantorInfoBlock from './../components/DashboardGuarantorInfo.vue'
import DashboardGuarantorAllowranceBlock from './../components/DashboardGuarantorAllowrance.vue'
import DashboardAnnouncementBlock from './../components/DashboardAnnouncement.vue'
import DashboardGuaListBlock from './../components/DashboardGuaList.vue'
import DashboardStatFiguresBlock from './../components/DashboardStatFigure.vue'
export default {
  name: 'Dashboard',
  props: {
  },
  components: {
    DashboardUserInfoBlock,
    DashboardGuarantorInfoBlock,
    DashboardGuarantorAllowranceBlock,
    DashboardAnnouncementBlock,
    DashboardGuaListBlock,
    DashboardStatFiguresBlock
  },
  data () {
    return {
    }
  },
  computed: {
    guarantorLoaded () {
      return this.$store.getters.guarantorInfo
        && this.$store.getters.guarantorInfo.name
    },
  },
  watch: {
  },
  created () {
  },
  mounted () {
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    changePwd () {
      this.$emit('changePwd', false)
    },
    bindMobile (rebind = false) {
      this.$emit('bindMobile', rebind)
    },
  }
}
</script>

<style lang="less">
.dashboard {
  .ivu-card-body {
    position: relative;
    height: 100%;
  }
}
</style>
